var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: { padding: "20px 0 20px 0", "background-color": "#ffffff" }
    },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "left",
                "align-items": "center"
              },
              attrs: { span: 24 }
            },
            [
              _c(
                "span",
                {
                  staticClass: "search-text",
                  staticStyle: { "z-index": "11" }
                },
                [_vm._v("Still have")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "left",
                "align-items": "center"
              },
              attrs: { span: 24 }
            },
            [
              _c(
                "span",
                {
                  staticClass: "search-text",
                  staticStyle: { "z-index": "11" }
                },
                [_vm._v("questions?")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                padding: "0 16px 16px 16px"
              },
              attrs: { span: 24 }
            },
            [
              _c(
                "el-button",
                { staticClass: "help-btn", attrs: { type: "primary" } },
                [_vm._v("Help Center")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ffd2e914", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffd2e914","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/stillHaveQuestions.vue
// module id = null
// module chunks = 